module.exports = __webpack_public_path__ + "img/hong_kong_2015_2.37e2ccf7.png";